import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';
import { resolveApiErrorMessage } from '@formosa/shared/i18n/resolveApiErrorMessage';

/**
 * 保留超過 Number.MAX_SAFE_INTEGER 的 Snowflake ID 精度。
 */
function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:id|blocker_member_id|blocked_member_id|blockedMemberId|blockerMemberId|targetId|memberId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

/**
 * 產生安全操作的唯一 clientRequestId。
 */
export function newSafetyClientRequestId(prefix = 'safety') {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

/**
 * 解析安全操作的錯誤訊息。
 */
export function safetyErrorMessage(cause, t, fallbackKey = 'travel.safety.actionFailed') {
  if (typeof t !== 'function') {
    return resolveApiErrorMessage(cause, (key) => key, fallbackKey);
  }
  return resolveApiErrorMessage(cause, t, fallbackKey);
}

/**
 * Travel Social 安全防護 API。
 * 支援檢舉、封鎖、解除封鎖 (CAS)、封鎖清單。
 * memberId 與 targetId 保持字串安全。
 */
export const travelSafetyApi = {
  report: ({ targetType, targetId, reason, note, clientRequestId }) =>
    travelClient.post(
      travelEndpoints.socialReports,
      {
        targetType,
        targetId: String(targetId),
        reason,
        note: note || null,
        clientRequestId,
      },
      snowflakeJson,
    ),

  reportMember: ({ memberId, reason, note, clientRequestId }) =>
    travelSafetyApi.report({
      targetType: 'MEMBER',
      targetId: String(memberId),
      reason,
      note,
      clientRequestId,
    }),

  blockMember: (memberId, clientRequestId) =>
    travelClient.post(
      travelEndpoints.socialBlock(String(memberId)),
      { clientRequestId },
      snowflakeJson,
    ),

  unblockMember: (memberId, expectedRowVersion) =>
    travelClient.delete(travelEndpoints.socialBlock(String(memberId)), {
      params: { expectedRowVersion: Number(expectedRowVersion) },
      ...snowflakeJson,
    }),

  listBlocks: () => travelClient.get(travelEndpoints.socialBlocks, snowflakeJson),
};
